import { OURA_DISCOUNT_CURRENCY, Price } from '@naturalcycles/shared'

export const ouraRingDiscount = '10%'
export const ouraRingDiscountedPriceAB368 = '$50 off'

export function getOuraDiscountAsPrice(country: string): Price {
  if (OURA_DISCOUNT_CURRENCY[country] === 'EUR') {
    return new Price('40[EUR]')
  }
  return new Price('40[USD]')
}
